module.exports = __webpack_public_path__ + "static/img/pr_bg_0.fdad96c1.png";